import { randomNumber } from '../../../../utilities/randomNumber.util'
import { PnProcedureConstants } from './pnProcedure.constants'
import { IPnProcedureState, IPnProcedureAction, IAddPnProcedure } from './pnProcedure.types'

export const initialAddPnProcedure: IAddPnProcedure = {
  id: randomNumber(),
  date: '',
  time: '',
  pta: false,
  assessedBy: null,
  attempts: '',
  size: '',
  procedureComplications: [],
  response: null,
  authorization: null,
  comments: '',
  type: '',
  rolePerforming: null,
  nemsisCode: '',
  nemsisCodePNNV: null,
}

export const initialPnProcedureState: IPnProcedureState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  assessedBy: null,
  pnProcedure: null,
  procedurePNNVs: [],
  addToTimeline: false,
  type: 'PnProcedure',
}

export function pnProcedureReducer(
  state: IPnProcedureState = initialPnProcedureState,
  action: IPnProcedureAction
): IPnProcedureState {
  switch (action.type) {
    case PnProcedureConstants.SET_PN_PROCEDURE:
      return { ...state, pnProcedure: action.pnProcedure }
    case PnProcedureConstants.SET_PN_PROCEDURE_LIST:
      return { ...state, procedurePNNVs: action.procedurePNNVs }
    case PnProcedureConstants.SET_TIME:
      return { ...state, time: action.time }
    case PnProcedureConstants.SET_DATE:
      return { ...state, date: action.date }
    case PnProcedureConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case PnProcedureConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case PnProcedureConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case PnProcedureConstants.SET_STATE:
      return { ...action.pnProcedureState }
    case PnProcedureConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        assessedBy: null,
        pnProcedure: null,
        procedurePNNVs: [],
        addToTimeline: false,
        type: 'PnProcedure',
      }
    default:
      return state
  }
}
